<template>
  <el-dialog
    title="不可租标签"
    :visible.sync="show"
    width="50%"
    :before-close="closeModal"
  >
    <div>
      <el-form>
        <el-form-item label="不可租标签" label-width="100px">
          <el-checkbox-group v-model="checked">
            <el-checkbox
              v-for="(item, index) in allNonRentTagList"
              :label="item.id"
              :key="index"
            >
            {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getNonRentableList } from '@/api/domain/organize'
import { editTag } from '@/api/domain/cars'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  name: 'NonRentableTag',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentId: {
      type: [String, Number],
      default: '',
    },
    checkedList: {
      type: Array,
      default: () => [],
    },
    searchHandle: Function,
  },
  data() {
    return {
      allNonRentTagList: [],
      show: this.dialogVisible,
      checked: this.checkedList,
      submitLoading: false,
    }
  },
  watch: {
    checkedList: {
      handler(val) {
        this.checked = val
      },
      deep: true,
    },
    dialogVisible(val) {
      this.show = val
      if (val) {
        this.submitLoading = false
        this.handleTenantCustomTagList()
      }
    },
  },
  methods: {
    // 获取车辆不可租标签
    async handleTenantCustomTagList() {
      const { code, data } = await getNonRentableList({ type: 1 })
      if (code !== 1) return
      this.allNonRentTagList = data.nonRentableTagList || []
    },
    // 提交已选标签
    async handleSubmit() {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        const params = {
          id: this.currentId,
          nonRentableTagList: this.checked,
        }
        const { code } = await editTag(params)
        if (code !== 1) {
          this.submitLoading = false
          return
        }
        this.closeModal()
        this.$message.success('编辑成功')
        // 更新父组件的列表数据
        this.searchHandle && this.searchHandle()
        this.sendMessage()
        // 成功后不重置 submitLoading，弹窗关闭动画期间按钮仍禁用，避免二次提交（重开时在 watch 里重置）
      } catch {
        this.submitLoading = false
      }
    },
    closeModal() {
      this.show = false
      this.$emit('update:dialogVisible', false)
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
}
</script>
